import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import MetaFormInline from 'Components/UI/Meta/MetaForm/Components/MetaFormInline';
import useMobileLayout from 'Hooks/useMobileLayout';

import ReadOnlyGoalForm from '../ReadOnlyGoalForm';
import GoalTodoList from '../GoalTodoList';
import GoalTools from '../GoalTools';
import { displayInfo } from '../../../../../../Helpers/FacetNotificationManager';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.common.white,
    width: '100%',
    maxWidth: theme.dimensions.xxl,
    height: '100%',
    overflowY: 'auto',
  },
  form: {
    flex: '1',
  },
  formFieldListControl: {
    paddingLeft: 0,
    marginLeft: theme.spacing(3),
  },
  goalTools: {
    marginBottom: theme.spacing(4),
  },
}));

const GoalForm = ({
  onSubmit,
  onDelete,
  goalResource,
  selectedGoalType,
  readOnly,
  toggleReadOnly,
  onMarkCompleted,
}) => {
  const classes = useStyles();
  const isMobile = useMobileLayout();
  const rows = [
    ['type', 'name', 'priority'],
    ['amount', 'amountSaved', 'endDate'],
  ];

  const mobileRows = [
    ['type'],
    ['name'],
    ['priority'],
    ['amount'],
    ['amountSaved'],
    ['endDate'],
  ];

  const onFailure = err => displayErrorMessage(err, err.errors);

  const onChange = (attrName, value) => {
    if (attrName === 'amount' || attrName === 'amountSaved') {
      const currentAmount = parseInt(value, 10);
      if (currentAmount >= 10000000) {
        displayInfo('Max amount is $10M.');
      }
    }
  };

  const goalDetail = readOnly && !selectedGoalType ? (
    <ReadOnlyGoalForm goalResource={goalResource} onEdit={toggleReadOnly} onMarkCompleted={onMarkCompleted} />
  ) : (
    <MetaFormInline
      className={classes.form}
      classes={{
        root: classes.form,
        fieldListControlNotFirst: classes.formFieldListControl,
      }}
      resource={goalResource}
      rows={isMobile ? mobileRows : rows}
      onSubmit={onSubmit}
      onFailure={onFailure}
      onChange={onChange}
      onDelete={goalResource.resourceId ? onDelete : null}
      confirmDeleteMessage={`You are about to delete your "${goalResource.attr('name')}" goal. Would you like to delete?`}
    />
  );

  return (
    <div className={classes.root}>
      {goalResource && (
        <>
            {goalDetail}
            {(readOnly && !selectedGoalType) ? (
              <GoalTools
                className={classes.goalTools}
                goalResource={goalResource}
              />
            ) : null}
            {readOnly && !selectedGoalType && <GoalTodoList goal={goalResource} />}
        </>
      )}
    </div>
  );
};
GoalForm.defaultProps = {
  selectedGoalType: null,
};
GoalForm.propTypes = {
  goalResource: PropTypes.object.isRequired,
  selectedGoalType: PropTypes.string,
  readOnly: PropTypes.bool.isRequired,
  toggleReadOnly: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onMarkCompleted: PropTypes.func.isRequired,
};

export default GoalForm;
